export const WEB_PATH = "monetization/payment";
export const SAVED_DESIGN_PATH = "design/saved";
export const GUIDE_DESIGN_PATH = "design/guide";
export const FONTS_DESIGN_PATH = "design/fonts";
export const INTEGRATION_PATH = "monetization/integrations";